import { AddressModel, useAddressList, useCurrentCity } from '@entities/address'
import { FocusEvent, LegacyRef, useEffect, useState } from 'react'
import { InputActionMeta } from 'react-select'

import { useGetAddressList, useSetCurrentAddress } from '../store/address.store'

export const useSearchAddress = (ref: LegacyRef<any>) => {
  const [address, setAddress] = useState<string>('')
  const [isFocused, setIsFocused] = useState<boolean>(false)
  const setCurrentAddress = useSetCurrentAddress()

  const city = useCurrentCity()
  const { getAddressList } = useGetAddressList()
  const { addresses: addressesByPart, status } = useAddressList()

  useEffect(() => {
    address.length > 0 &&
      getAddressList({
        addressPart: address,
        page: 1,
        city: city?.getCity() ?? ''
      })
  }, [address, city, getAddressList])

  const autocompleteItems = addressesByPart || []

  const handleAddressSelect = (option: AddressModel): void => {
    const optionAddress = option.getAddress()
    setAddress(optionAddress ?? '')
    setCurrentAddress(option)
    if (ref && typeof ref !== 'string' && 'current' in ref) {
      ref?.current.blur()
    }
  }

  const handleAddressPartChange = (
    text: string,
    actionMeta: InputActionMeta
  ): void => {
    if (
      actionMeta.action === 'input-change' ||
      actionMeta.action === 'set-value'
    ) {
      setAddress(text)
    }
  }

  const handleFocus = (_: FocusEvent<HTMLInputElement, Element>) => {
    setIsFocused(true)
  }
  const handleBlur = (_: FocusEvent<HTMLInputElement, Element>) => {
    setIsFocused(false)
  }

  const isMenuOpened =
    isFocused &&
    address.length > 0 &&
    addressesByPart?.length > 0 &&
    autocompleteItems[0].getAddress() !== city?.getCity()

  return {
    isMenuOpened,
    address,
    autocompleteItems,
    handleAddressPartChange,
    handleAddressSelect,
    handleFocus,
    handleBlur,
    status
  }
}
